import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { useAtom } from "jotai";

import TopBar from "../components/layout/TopBar";
import BottomNav from "../components/layout/BottomNav";
import PhotoViewer from "../components/common/PhotoViewer";
import NotificationService from "../components/common/NotificationService";

import Home from "../components/home/Home";
import CCTVList from "../components/cctv/CCTVList";
import Schedule from "../components/schedule/Schedule";
import Support from "../components/support/Support";
import More from "../components/more/More";

import CameraView from "../components/cctv/CameraView";
import CheckInHistory from "../components/common/CheckInHistory";
import Chat from "../components/common/Chat";
import NewsRoom from "../components/common/NewsRoom";
import Survey from "../components/common/Survey";

import Profile from "../components/more/Profile";
import MyChildren from "../components/more/MyChildren";
import MySchool from "../components/more/MySchool";
import Gallery from "../components/more/Gallery";
import Growth from "../components/more/Growth/Growth";
import Videos from "../components/more/Videos";
import ReferralCode from "../components/more/ReferralCode";
import PickupAuthorizations from "../components/more/PickupAuthorizations";
import PickupAuthorizationHistory from "../components/more/PickupAuthorizationHistory";

// Support forms...
import TakeBreak from "../components/support/forms/TakeBreak";
import Reload from "../components/common/Reload";
import ExtendPause from "../components/support/forms/ExtendPause";
import EarlyResume from "../components/support/forms/EarlyResume";
import ChangeProgram from "../components/support/forms/ChangeProgram";
import Transport from "../components/support/forms/Transport";
import ShiftCenter from "../components/support/forms/ShiftCenter";
import WithdrawChild from "../components/support/forms/Withdraw";
import ExtendedDaycare from "../components/support/forms/ExtendedDaycare";
import Finance from "../components/support/forms/Finance";
import FeeCertificate from "../components/support/forms/FeeCertificate";
import NonSatisfaction from "../components/support/forms/NonSatisfaction";
import ShareFeeCertificate from "../components/support/forms/ShareFeeCertificate1";
import Contact from "../components/support/forms/Contact";
import DoorPin from "../components/support/forms/DoorPin";
import RaiseTicket from "../components/support/forms/RaiseTicket";
import PastRequests from "../components/support/PastRequests";
import Notifications from "../components/common/Notifications";
import OutdoorActivity from "../components/common/OutdoorActivity";
import { appConstants, activeChildDetail } from "../atomstore/store";
import { isVisitorPickupVisibleForCenter } from "../utils/visitorPickupConfig";
import { isReferFriendsVisible } from "../utils/referralConfig";
// import all other forms...

const ReferralRoute = ({ children }) => {
    const [constants] = useAtom(appConstants);
    if (!isReferFriendsVisible(constants)) {
        return <Navigate to="/more" replace />;
    }
    return children;
};

const VisitorPickupRoute = ({ children }) => {
    const [constants] = useAtom(appConstants);
    const [activeChild] = useAtom(activeChildDetail);
    if (!isVisitorPickupVisibleForCenter(constants, activeChild?.center_id)) {
        return <Navigate to="/more" replace />;
    }
    return children;
};

const AppLayout = ({ selectedPhoto, setSelectedPhoto, activeTab, setActiveTab }) => {
    return (
        <>
            <Reload />


            <div className="flex flex-col h-full overflow-hidden">
                <TopBar />
                <div className="flex-grow overflow-y-auto pb-20">
                    <Routes>

                        {/* Tabs */}
                        <Route path="home" element={<Home setSelectedPhoto={setSelectedPhoto} />} />
                        <Route path="cctv" element={<CCTVList />} />
                        <Route path="schedule" element={<Schedule />} />
                        <Route path="support" element={<Support />} />
                        <Route path="more" element={<More />} />

                        {/* Details */}
                        <Route path="camera-view" element={<CameraView />} />
                        <Route path="checkin-history" element={<CheckInHistory />} />
                        <Route path="chat" element={<Chat />} />
                        <Route path="newsroom" element={<NewsRoom />} />
                        <Route path="notifications" element={
                            <Notifications setSelectedPhoto={setSelectedPhoto} />
                        } />
                        <Route path="outdoor-activity" element={<OutdoorActivity />} />


                        <Route path="survey" element={<Survey />} />

                        {/* More */}
                        <Route path="profile" element={<Profile />} />
                        <Route path="my-children" element={<MyChildren />} />
                        <Route path="my-school" element={<MySchool />} />
                        <Route path="gallery" element={<Gallery />} />
                        <Route path="growth" element={<Growth />} />
                        <Route path="videos" element={<Videos />} />
                        <Route path="referral" element={
                            <ReferralRoute>
                                <ReferralCode />
                            </ReferralRoute>
                        } />
                        <Route path="pickup-authorizations" element={
                            <VisitorPickupRoute>
                                <PickupAuthorizations />
                            </VisitorPickupRoute>
                        } />
                        <Route path="pickup-authorizations/:personId/history" element={
                            <VisitorPickupRoute>
                                <PickupAuthorizationHistory />
                            </VisitorPickupRoute>
                        } />

                        {/* Support forms */}
                        <Route path="take-break" element={<TakeBreak />} />
                        <Route path="extend-pause" element={<ExtendPause />} />
                        <Route path="early-resume" element={<EarlyResume />} />
                        <Route path="change-program" element={<ChangeProgram />} />
                        <Route path="transport" element={<Transport />} />
                        <Route path="shift-center" element={<ShiftCenter />} />
                        <Route path="withdraw" element={<WithdrawChild />} />
                        <Route path="extend-daycare" element={<ExtendedDaycare />} />
                        <Route path="finance" element={<Finance />} />
                        <Route path="fee" element={<FeeCertificate />} />
                        <Route path="non-satisfaction" element={<NonSatisfaction />} />
                        <Route path="share-certificate" element={<ShareFeeCertificate />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="door-pin" element={<DoorPin />} />
                        <Route path="raise" element={<RaiseTicket />} />
                        <Route path="past-request" element={<PastRequests />} />

                        {/* Default route */}
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>

                <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />

            </div>
            {selectedPhoto && (
                <PhotoViewer photo={selectedPhoto} onClose={() => setSelectedPhoto(null)} />
            )}
        </>
    );
};

export default AppLayout;
